import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const getWidgetSettings= async (domain: string, widgetType: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `widget/settings`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        params: { widgetType },
        isEncrypted: true,
    });
}